import {useLoaderData, useOutlet} from "react-router-dom";
import {AuthProvider} from "../hooks/useAuth";

function AuthLayout() {
    const outlet = useOutlet();

    const user = useLoaderData();

    return <AuthProvider userData={user}>{outlet}</AuthProvider>;
}

export {AuthLayout};
